import { GameCarousel } from './games/game-carousel';
import { HomeGame } from '@/types/game';
import { useQuery } from '@tanstack/react-query';
import { NewGameItem } from '@/types/new-game-item';
import { fetcher } from '@/lib/queryClient';

export function NewGamesCarousel() {
  const { data: newGames = [] } = useQuery<NewGameItem[]>({
    queryKey: ['/api/new-games'],
    queryFn: fetcher,
  });

  const filteredNewGames: HomeGame[] = newGames
    .sort((a, b) => a.order - b.order)
    .map((newGame) => newGame.game);

  return <GameCarousel games={filteredNewGames} title="Новые игры" disableNavigation />;
}
